import { Injectable } from "@angular/core";
import { AuthorizationCodeRequestConfigurationService } from "../../configuration/auth/authorization-code-request-configuration/authorization-code-request-configuration.service";
import { ClientConfigurationService } from "../../configuration/auth/client/client-configuration.service";
import { Utils } from "src/app/shared/utils/utils";
import { AuthModule } from "../auth.module";

@Injectable({
  providedIn: AuthModule,
})
export class AuthorizationCodeRequestBodyFactoryService {
  constructor(
    private authorizationCodeRequestConfigurationService: AuthorizationCodeRequestConfigurationService,
    private clientConfigurationService: ClientConfigurationService
  ) {}

  get authorizationCodeRequestConfiguration() {
    return this.authorizationCodeRequestConfigurationService.configuration;
  }

  get clientConfiguration() {
    return this.clientConfigurationService.configuration;
  }

  get grant_type() {
    return "authorization_code";
  }

  get redirect_uri() {
    return this.authorizationCodeRequestConfiguration.redirect_uri;
  }

  get client_id() {
    return this.clientConfiguration.clientId;
  }

  get contentType() {
    return this.authorizationCodeRequestConfiguration.contentType;
  }

  createBody(code) {
    if (this.contentType === "application/x-www-form-urlencoded") {
      return this.createFormUrlEncodedBody(code);
    } else {
      throw new Error("Content type not implemented");
    }
  }

  private createFormUrlEncodedBody(code: any) {
    const body = {
      grant_type: this.grant_type,
      redirect_uri: this.redirect_uri,
      client_id: this.client_id,
      code: code,
    };
    return Utils.getFormUrlEncodedObject(body);
  }
}
